import * as React from 'react';
import StarIcon from './StarIcon';

type StarProps = {
  isFilled: boolean;
  onMouseEnter: () => void;
  onMouseLeave: () => void;
  onSubmit: () => void;
};

const Star: React.FC<StarProps> = ({ isFilled, onMouseEnter, onMouseLeave, onSubmit }: StarProps) => {
  return (
    <span
      className="ml-4 mr-3 cursor-pointer"
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onClick={onSubmit}
      onKeyDown={onSubmit}
      data-testid="star-rating-star-container"
    >
      <StarIcon
        data-testid="star-rating-star-svg"
        fill={isFilled ? 'var(--ex3d-star-rating-color)' : 'none'}
        stroke={isFilled ? 'none' : 'black'}
      />
    </span>
  );
};

export default Star;
